/* eslint-disable max-len */
import { useReducer } from 'react';
import { getNowDateTimeInET, convertTimeStampToEtDateTime } from '../helpers/timeHelpers';

const initialState = {
  ap_full_location: '',
  checkout_code: {},
  checkout_token: '',
  cloudinary_company_logo: null,
  cloudinary_header_image: '',
  company_city: '',
  company_country: '',
  company_description: '',
  company_name: '',
  company_state_territory: '',
  company_url: '',
  coupon_code_id: null,
  crosspost_sites: [],
  edit_url: '',
  full_text: '',
  multimedia_add_ons: [],
  newsletter_add_ons: [],
  orig_summary: '',
  payment_intent_id: null,
  press_contacts: [],
  preview_url: '',
  price_per_press_release: null,
  publish_date: '',
  self_subscribe: false,
  source_link: '',
  subheader: '',
  submitted_date: '',
  submitter_company: '',
  submitter_email: '',
  submitter_ip_address: '',
  submitter_name: '',
  submitter_title: '',
  title: '',
  topic_newsletter_add_ons: [],
  url: '',
};

const setPublishDate = (value) => {
  if (value) {
    if (convertTimeStampToEtDateTime(value) > getNowDateTimeInET()) return value;
  }
  return null;
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_MULTIMEDIA':
      return {
        ...state,
        multimedia_add_ons: [...action.payload],
      };
    case 'SET_PRESS_RELEASE':
      return {
        ...{ ...state, ...action.payload },
        // temporary patch for removing placeholder title and company_name until we can migrate to make them non-required fields
        /* eslint-disable camelcase */
        title: action.payload?.title === `placeholder_title__${action.payload?.checkout_token}` ? ''
          : { ...state, ...action.payload }.title,
        company_name: action.payload?.company_name === `placeholder_company__${action.payload?.checkout_token}` ? ''
          : { ...state, ...action.payload }.company_name,
        publish_date: setPublishDate({ ...state, ...action.payload }.publish_date),
      };
    case 'ADD_CONTACT':
      return {
        ...state,
        press_contacts: [
          ...state.press_contacts,
          {
            name: '',
            email: '',
            phone_number: '',
          },
        ],
      };
    case 'UPDATE_CONTACT':
      return {
        ...state,
        press_contacts: [
          ...state.press_contacts.slice(0, action.payload.index),
          {
            ...state.press_contacts[action.payload.index],
            [action.payload.key]: action.payload.value,
          },
          ...state.press_contacts.slice(action.payload.index + 1),
        ],
      };
    case 'DELETE_CONTACT':
      return {
        ...state,
        press_contacts: [
          ...state.press_contacts.slice(0, action.payload.index),
          ...state.press_contacts.slice(action.payload.index + 1),
        ],
      };
    case 'ADD_ACTIVE_CODE':
      return {
        ...state,
        checkout_code: action.payload,
      };
    case 'REMOVE_ACTIVE_CODE':
      return {
        ...state,
        checkout_code: {},
      };
    default:
      throw new Error();
  }
};

const usePressReleaseReducer = () => {
  return useReducer(reducer, initialState);
};

export default usePressReleaseReducer;
